module.exports = __webpack_public_path__ + "img/ball_1.f39d2b86.png";